import React, { useState } from 'react';
import { TextField, Button, Box, Typography, Grid } from '@mui/material';
import emailjs from 'emailjs-com'
import { Email, Facebook, PhoneIphone } from '@mui/icons-material';
import Divider from '@mui/material/Divider';
import {useMediaQuery} from '@mui/material';

const ContactForm = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'));
  const isDesktop = useMediaQuery(theme => theme.breakpoints.up('md'));

  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    const templateParams = {
      email,
      name,
      phone,
      message,
    };

    emailjs
      .send(
        'service_a1uyvjy',
        'template_qxilt0k',
        templateParams,
        'aBU8ZybZIeH3CNhrm'
      )
      .then(
        (response) => {
          console.log('SUCCESS!', response.status, response.text);
          alert('Köszönöm a megkeresést! Hamarosan keresni fogom Önt.');
        },
        (error) => {
          console.log('FAILED...', error);
          alert(error);
        }
      );
  };

  return (
    <Grid container spacing={2} justifyContent="center" allignItems="stretch" disableGutters>            
        <Box container component="form" onSubmit={handleSubmit} boxShadow={4} padding={4} disableGutters>
          <Typography variant="h5" gutterBottom>
            Kérjen ajánlatot, vagy küldjön üzenetet
          </Typography>
          <TextField name="name" label="Az Ön neve" fullWidth margin="normal" onChange={(e) => setName(e.target.value)} required/>
          <TextField name="email" label="Email címe" fullWidth margin="normal" onChange={(e) => setEmail(e.target.value)} required/>
          <TextField name="phone" label="Telefonszáma" fullWidth margin="normal" onChange={(e) => setPhone(e.target.value)} />
          <TextField name="message" label="Miben segíthetek?" fullWidth multiline rows={4} margin="normal" onChange={(e) => setMessage(e.target.value)} required/>
          <Button type="submit" variant="contained" color="primary" sx={{ mt: 2 }}>
            Küldés
          </Button>
        </Box>         
        
        {isDesktop && (
        <Box container margin={2} boxShadow={4} padding={4} disableGutters >
          <Typography variant="h5" gutterBottom sx={{ mb: 4 }} >            
            Elérhetőségek
          </Typography>
          <Grid container sx={{ mb: 4, mt: 4 }} disableGutters >
            <PhoneIphone fontSize='large' sx={{ mr: 2 }} item xs={2}/>
            <Typography variant="h6">+36 20 278 7043 </Typography>
            <Divider orientation="vertical" flexItem sx={{ mr: 4, ml : 4 }} />

            <Email fontSize='large' sx={{ mr: 2}} item xs={2}></Email>
            <Typography variant="h6">tomhouse.ev@gmail.com</Typography>
            <Divider orientation="vertical" flexItem sx={{ mr: 4, ml : 4 }} />
            <Facebook fontSize='large' sx={{ mr: 2 }} item xs={2}></Facebook>
            <Typography variant="h6"><a href="https://www.facebook.com/people/Tom-House/100063736346422/" target="_blank" rel="noopener noreferrer">Tom-House</a></Typography>
          </Grid> 
        </Box>        
        )}
        {isMobile && (
          <Box container margin={0} padding={4} disableGutters >
            <Grid container sx={{ m: 4 }} spacing={2}>
              <Grid item xs={12}>
                <Typography variant="h5" gutterBottom sx={{ mb: 4 }} >Elérhetőségek</Typography>
              </Grid>
              <Grid item xs={2}>
                <PhoneIphone fontSize='large' sx={{ mr: 2,}} />
              </Grid>
              <Grid item xs={10}>
                <Typography variant="h6">+36 20 278 7043</Typography>
              </Grid>               
            
              <Grid item xs={2}>
                <Email fontSize='large' sx={{ mr: 2}} item xs={2}></Email>
              </Grid>
               <Grid item xs={10}>
                <Typography variant="h6">tomhouse.ev@gmail.com</Typography>
              </Grid>
              <Grid item xs={2}>
                <Facebook fontSize='large' sx={{ mr: 2 }} item xs={2}></Facebook>
              </Grid>
              <Grid item xs={10}>
                <Typography variant="h6"><a href="https://www.facebook.com/people/Tom-House/100063736346422/" target="_blank" rel="noopener noreferrer">Tom-House</a></Typography>
              </Grid>
            </Grid>
          </Box>
            
          
        )}
    </Grid>
  );
}

export default ContactForm;